import { render, staticRenderFns } from "./processing-input.vue?vue&type=template&id=36ae4a27&scoped=true"
import script from "./processing-input.vue?vue&type=script&lang=js"
export * from "./processing-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae4a27",
  null
  
)

export default component.exports